import { useParams } from "react-router-dom";
import StockCard from "../components/ui/StockCard";
import apiClient from "../lib/api_client";
import { useQuery } from "@tanstack/react-query";
import StockCardSkeleton from "../components/ui/skeletons/StockCardSkeleton";

const StockCardPage = () => {
    const {styleNumber} = useParams();
    const payload = {
        "sortBy": "Design Date",
        "order": "asc",
        "searchTerm": "",
        "location": [
            "Headquarters Stock",
            "BBM Stock",
            "BBM Customer Stock",
            "BBS Stock",
            "BBS Customer Stock",
            "Idel Inventory"
        ],
        "goldColor": [
            "Yellow",
            "White",
            "Pink"
        ],
        "goldQlty": [
            "22K",
            "18K",
            "14K"
        ],
        "diaQlty": [
            "VVSEF",
            "VVSFG",
            "VVSGH",
            "VSSIGH",
            "RVVSEF",
            "VSGH",
            "SIIJ",
            "SIHI"
        ],
        "designClass": [
            "Gold",
            "Silver",
            "Bronze"
        ]
    }
    const getStyleData = async () => {
        const response = await apiClient.post("/getStyleNumberStockDetails", {...payload, styleNumber});
        return response?.data?.styleStocks;
    }

    const { data, isLoading, isError} = useQuery({
        queryKey: ["styleData", styleNumber],
        queryFn: getStyleData,
    })

    return (
        <div
            style={{
                backgroundColor: "#000",
                minHeight: "100vh",
                paddingLeft: "1.6vw",
                paddingTop: "2.5vw"
            }}
        >
            <h2 style={{color: "#fff", fontFamily: "Poppins", fontWeight: 400, fontSize: "1.2vw"}}>{styleNumber}{!isLoading && ` - ${data?.length}`}</h2>
            <div style={{display: "flex", alignItems: "center", flexWrap: "wrap", gap: '20px', marginTop: "1.6vw"}}>
                {isLoading ? (
                    Array.from({length: 6}, () => null).map((_, idx) => <StockCardSkeleton key={idx} />)
                ) : isError ? ( <p style={{color: "#fff", fontFamily: "Poppins", fontSize: "1vw"}}>Error loading data</p>
                ) : (
                    data?.map((item) => <StockCard key={item._id} data={item} />)
                )}
            </div>
        </div>
    )
}

export default StockCardPage;